import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VeeValidate from "vee-validate";
import moment from "moment";
import numeral from "numeral";

Vue.config.productionTip = false; //TODO turn ON for production
Vue.prototype.moment = moment;
Vue.prototype.numeral = numeral;

new Vue({
  router,
  store,
  vuetify,
  VeeValidate,
  render: (h) => h(App),
}).$mount("#app");
